import common from "../common";
import MiniSignal from "mini-signals";
import ControlMethodKeys from "./control/ControlMethodKeys";
import ControlMethodAI from "./control/ControlMethodAI";
import ControlMethodAITutorial from "./control/ControlMethodAITutorial";
import ControlMethodVirtualStick from "./control/ControlMethodVirtualStick";

export default class Fighter extends PIXI.Container
{
    constructor(gameScene, id, characterData, controlMethod, field, healthBar, tutorialMode)
    {
        super();

        this.id = id;

        this.gameScene = gameScene;
        this.characterData = characterData;
        this.controlMethod = controlMethod;
        this.field = field;
        this.healthBar = healthBar;
        this.tutorialMode = tutorialMode;

        var settings = common.config.settings.gamePhysics.fighters;
        this.attributes = {
            speed: settings.baseSpeed * characterData.speed,
            range: settings.baseRange[0] + ((settings.baseRange[1] - settings.baseRange[0]) * characterData.range),
            power: settings.basePower * characterData.power,
            inertia: settings.baseInertia * characterData.inertia,
        };

        this.dustSpine = null;

        this.visual = null;
        this.spine = null;
        this.control = null;

        this.input = {left:false, right:false, up:false, down:false, x:0, y:0};

        this.bounds = {
            x: -characterData.width/2,
            y: -characterData.height,
            width: characterData.width,
            height: characterData.height - 40
        };
        this.bounds.centerX = this.bounds.x + (this.bounds.width/2);
        this.bounds.centerY = this.bounds.y + (this.bounds.height/2);

        this.weapons = [{data: common.config.weapons.weapons.basic, ammo: null}];
        //this.projectileOffset = {x:(this.bounds.width/2) * this.field.direction, y:this.bounds.y + (this.bounds.height/2)}
        this.projectileOffset = this.characterData.projectileSpawn;

        this.movement = {x:0, y:0};
        this.inertia = {x:0, y:0};

        this.incapacitated = false;
        this.incapacitatedTimer = 0;
        this.incapacitatedTimerLimit = 2;

        this.deactivated = true;

        this.currentUpperAnimation = null;
        this.currentLowerAnimation = null;

        this.playingKOAnimation = false;

        this.shadow = null;

        this.nextProjectile = null;
        this.nextProjectilePoint = null;
        this.nextProjectileData = null;
        this.nextProjectileImageName = null;
        this.nextProjectileHoldImageName = null;
        this.nextProjectileShow = true;
        
        this.readyToFire = true;
        this.lastFire = 0;

        this.trajectoryEstimate = null;
        this.trajectoryEstimateDebug = new PIXI.Graphics();

        this.signals = {
            fireWeapon: new MiniSignal()
        };

        this.init();
    }

    init()
    {
        this.dustSpine = new PIXI.spine.Spine(P3.assets.spineData('vfx_spine'));
        this.dustSpine.scale.set(0.25);
        this.addChild(this.dustSpine);
        this.dustSpine.skeleton.setSlotsToSetupPose();
        this.dustSpine.skeleton.setToSetupPose();
        this.dustSpine.autoUpdate = false;

        if(this.characterData.spine)
        {
            var spineData = P3.assets.spineData(this.characterData.spine);
            this.visual = this.spine = new PIXI.spine.Spine(spineData);
            this.spine.scale.set(0.25);
            this.spine.scale.x = this.spine.scale.x * this.field.direction;
            this.addChild(this.spine);

            if(this.characterData.name === '???') this.spine.tint = 0x000000;

            if(this.characterData.skin)
            {
                this.spine.skeleton.setSkin(this.spine.spineData.findSkin(this.characterData.skin));
            }

            this.spine.skeleton.setSlotsToSetupPose();
            this.spine.skeleton.setToSetupPose();
            this.spine.autoUpdate = false;

            if(!this.tutorialMode)
            {
                this.visible = false;
                P3.utils.delay(0.5 + (0.5 * this.id), () => 
                { 
                    this.visible = true;
                    this.setUpperAnimation('char_enter_arena', false);
                    this.dustSpine.state.setAnimation(0, 'char_enter_arena', false);
                });
            }
            else
            {
                this.dustSpine.visible = false;
            }

            var arr = [{name:'char_enter_arena', exceptions:['char_enter_arena']}, 
                       {name:'body_char_ko', exceptions:[]}, 
                       {name:'body_run_bkwd', exceptions:['body_hit']}, 
                       {name:'body_run_fwd', exceptions:['body_hit']}, 
                       {name:'body_throw_std', exceptions:['body_throw_std', 'body_hit']},
                       {name:'body_hit', exceptions:['body_hit']},
                       {name:'body_idle_fight', exceptions:['body_hit']}, 
                       {name:'body_idle_lose', exceptions:[]}, 
                       {name:'body_idle_victory', exceptions:[]},
                       {name:'body_slip_sit_seq', exceptions:[]},
                       {name:'legs_char_ko', exceptions:[]},
                       {name:'legs_run_bkwd', exceptions:[]},
                       {name:'legs_run_fwd', exceptions:[]},
                       {name:'legs_throw_static', exceptions:[]},
                       {name:'legs_idle_fight', exceptions:[]},
                       {name:'legs_slip_sit_seq', exceptions:[]}
                    ];

            for(var i = 0; i < arr.length; i++)
            {
                for(var j = 0; j < arr.length; j++)
                {
                    if(arr[i].exceptions.indexOf(arr[j].name) < 0 &&
                        this.spine.state.hasAnimationByName(arr[i].name) &&
                        this.spine.state.hasAnimationByName(arr[j].name)
                    )
                    {
                        this.spine.stateData.setMix(arr[i].name, arr[j].name, 0.2);
                    }
                }    
            }

            this.spine.state.addListener(
                {
                    event: function(entry, event)
                    {
                        if(event.data.name == 'food_release')
                        {
                            
                        }
                        else if(event.data.name == 'food_reload')
                        {
                            this.nextProjectileShow = true;
                        }
                        else if(event.data.name == 'sfx_land')
                        {
                            common.audio.playSound(['sfx_char_land_00', 'sfx_char_land_01']);
                            this.gameScene.shakeScene(0.1);
                        }
                        else if(event.data.name == 'sfx_slip')
                        {
                            common.audio.playSound(['sfx_char_slip_00', 'sfx_char_slip_01', 'sfx_char_slip_02', 'sfx_char_slip_03']);
                            common.audio.playSound(['sfx_crowd_laughter_00', 'sfx_crowd_laughter_01', 'sfx_crowd_laughter_02', 'sfx_crowd_laughter_03', 'sfx_crowd_laughter_04', 'sfx_crowd_laughter_05', 'sfx_crowd_laughter_06', 'sfx_crowd_laughter_07', 'sfx_crowd_laughter_08'])
                        }
                        else if(event.data.name == 'sfx_footstep')
                        {
                            common.audio.playSound(['sfx_footstep_mid_00', 'sfx_footstep_mid_01', 'sfx_footstep_mid_02', 'sfx_footstep_mid_03', 'sfx_footstep_mid_04'])
                        }
                        
                    }.bind(this),
                    complete: function(entry)
                    { 
                        var anim = entry.animation.name;
                        if(anim === 'char_enter_arena' || anim === 'body_throw_std' || anim === 'body_hit')
                        {
                            this.setUpperAnimation('body_idle_fight');
                        }
                        else if(anim === 'char_enter_arena')
                        {
                            this.setUpperAnimation('body_idle_fight');
                        }
                        else if(anim === 'body_char_ko')
                        {
                            this.playingKOAnimation = false;
                            this.setUpperAnimation('body_idle_victory');
                            this.setLowerAnimation('legs_idle_victory');
                        }
                    }.bind(this)
                });

            //common.display.rectangle({rect:this.bounds, lineColour:parseInt(this.characterData.colour, 16), parent:this});
        }
        else
        {
            this.visual = common.display.rectangle({rect:this.bounds, fillColour:parseInt(this.characterData.colour, 16), parent:this});
        }
        this.x = this.field.x + (this.field.width/2);
        this.y = this.field.y + (this.field.height/2);

        if(this.controlMethod === Fighter.CONTROL_KEYS)
        {
            this.control = new ControlMethodKeys(this);
            this.gameScene.signalListeners.push(this.control.signals.fireProjectile.add(this.fire, this))
            this.gameScene.signalListeners.push(this.control.signals.on.add(this.onControlKeyDown, this));
            this.gameScene.signalListeners.push(this.control.signals.off.add(this.onControlKeyUp, this));
        }
        else if(this.controlMethod === Fighter.CONTROL_AI)
        {
            this.control = new ControlMethodAI(this);
            this.gameScene.signalListeners.push(this.control.signals.fireProjectile.add(this.fire, this))
        }
        else if(this.controlMethod === Fighter.CONTROL_AI_TUTORIAL)
        {
            this.control = new ControlMethodAITutorial(this);
            this.gameScene.signalListeners.push(this.control.signals.fireProjectile.add(this.fire, this))
        }
        else if(this.controlMethod === Fighter.CONTROL_VIRTUAL_STICK)
        {
            this.control = new ControlMethodVirtualStick(this, this.gameScene.virtualStick);
            this.gameScene.signalListeners.push(this.control.signals.fireProjectile.add(this.fire, this));
            this.gameScene.signalListeners.push(this.control.signals.on.add(this.onControlKeyDown, this));
            this.gameScene.signalListeners.push(this.control.signals.off.add(this.onControlKeyUp, this));
        }

        this.shadow = common.display.sprite({asset:'food_shadow', anchor:0.5, scaleX:0.9, scaleY:0.42, alpha:0.8, parent:this.gameScene.projectileUnderLayer});
        
        this.nextProjectile = common.display.sprite({anchorX:0.5, anchorY:1, scale:0.3, parent:this});
        this.nextProjectilePoint = this.spine.skeleton.findBone('food_point');
        this.setNextProjectile();
        this.calculateTrajectoryEstimate();

        var fr = common.config.settings.gamePhysics.fighters.fireRate;
        this.attributes.fireLimit = (fr[0] + ((1 - this.characterData.speed) * (fr[1] - fr[0])));
    }

    destroy()
    { 
        super.destroy();
    }

    update()
    {
        if(this.control)
            this.control.update();

        if(this.spine)
            this.spine.update(P3.Ticker.dt * common.timeStretch);

        this.dustSpine.update(P3.Ticker.dt * common.timeStretch);

        this.movement.x = this.movement.y = 0;

        if(this.deactivated)
        {
            if(this.gameScene.completed)
            {
                if(this.gameScene.winner == this.id)
                {
                    if(this.currentUpperAnimation != 'body_idle_victory')
                        this.setUpperAnimation('body_idle_victory');
                    if(this.currentLowerAnimation != 'legs_idle_victory')
                        this.setLowerAnimation('legs_idle_victory');
                }
                else
                {
                    if(!this.playingKOAnimation)
                    {
                        if(this.currentUpperAnimation != 'body_idle_lose')
                            this.setUpperAnimation('body_idle_lose');
                        if(this.currentLowerAnimation != 'legs_idle_lose')
                            this.setLowerAnimation('legs_idle_lose');
                    }
                    else
                    {
                        if(this.currentUpperAnimation != 'body_char_ko')
                            this.setUpperAnimation('body_char_ko', false);
                        if(this.currentLowerAnimation != 'legs_char_ko')
                        {
                            this.setLowerAnimation('legs_char_ko', false);
                            this.dustSpine.state.setAnimation(0, 'char_ko', false);
                        }
                    }
                }
            }
        }
        else if(this.incapacitated)
        {
            this.incapacitatedTimer -= P3.Ticker.dt * common.timeStretch;
            if(this.incapacitatedTimer < 0)
            {
                this.capacitate();
            }
            else
            {
                if(this.currentUpperAnimation != 'body_slip_sit_seq')
                {
                    this.setUpperAnimation('body_slip_sit_seq', false);
                }
                if(this.currentLowerAnimation != 'legs_slip_sit_seq')
                {
                    this.setLowerAnimation('legs_slip_sit_seq', false);
                    this.dustSpine.state.setAnimation(0, 'char_slip_sit_seq', false);
                }
            } 
        }
        else//if(this.controlMethod === Fighter.CONTROL_KEYS)
        {
            var x = 0;
            var y = 0;

            if(this.input.left)
                x = -1;
            if(this.input.right)
                x = 1;
            if(this.input.down)
                y = 1;
            if(this.input.up)
                y = -1;

            if(x !== 0 || y !== 0)
            {
                var angle = Math.atan2(y, x);
                if(angle < 0) angle = (2*Math.PI) + angle;

                this.movement.y = Math.sin(angle);
                this.movement.x = Math.cos(angle);
            }
            else
            {
                this.movement.x = this.control.movement.x;
                this.movement.y = this.control.movement.y;
            }
        }

        this.inertia.x = P3.math.clamp(this.inertia.x + (this.movement.x * this.attributes.inertia), -1, 1);
        this.inertia.y = P3.math.clamp(this.inertia.y + (this.movement.y * this.attributes.inertia), -1, 1);

        if(this.movement.x == 0)
        {
            if(this.inertia.x > 0)
                this.inertia.x = P3.math.clamp(this.inertia.x - this.attributes.inertia, 0, 1);
            else if(this.inertia.x < 0)
                this.inertia.x = P3.math.clamp(this.inertia.x + this.attributes.inertia, -1, 0);
        }
        if(this.movement.y == 0)
        {
            if(this.inertia.y > 0)
                this.inertia.y = P3.math.clamp(this.inertia.y - this.attributes.inertia, 0, 1);
            else if(this.inertia.y < 0)
                this.inertia.y = P3.math.clamp(this.inertia.y + this.attributes.inertia, -1, 0);
        }

        var moveX = this.inertia.x * (this.attributes.speed * (P3.Ticker.dt * common.timeStretch));
        var moveY = this.inertia.y * (this.attributes.speed * (P3.Ticker.dt * common.timeStretch));

        this.x += moveX;
        this.y += moveY;

        if(!this.deactivated && !this.incapacitated)
        {
            if(Math.abs(moveX) < 0.25 && Math.abs(moveY) < 0.25)
            {
                if(this.currentUpperAnimation === 'body_throw_std' 
                    && this.currentLowerAnimation !== 'legs_throw_static')
                {
                    this.setLowerAnimation('legs_throw_static');
                }
                else if(this.currentLowerAnimation !== 'legs_idle_fight')
                {
                    this.setLowerAnimation('legs_idle_fight');
                }
                
                if(this.currentUpperAnimation !== 'body_idle_fight'
                    && this.currentUpperAnimation !== 'body_throw_std'
                    && this.currentUpperAnimation !== 'body_hit'
                )
                {
                    this.setUpperAnimation('body_idle_fight');
                }
            }
            else
            {
                if(Math.sign(moveX) == this.field.direction)
                {
                    if(this.currentLowerAnimation !== 'legs_run_fwd')
                    {
                        this.setLowerAnimation('legs_run_fwd');
                    }
                    if(this.currentUpperAnimation !== 'body_run_fwd' 
                        && this.currentUpperAnimation !== 'body_throw_std'
                        && this.currentUpperAnimation !== 'body_hit'
                        )
                    {
                        this.setUpperAnimation('body_run_fwd');
                    }
                }
                else if(Math.sign(moveX) != this.field.direction)
                {
                    if(this.currentLowerAnimation !== 'legs_run_bkwd')
                    {
                        this.setLowerAnimation('legs_run_bkwd');
                    }
                    if(this.currentUpperAnimation !== 'body_run_bkwd' 
                        && this.currentUpperAnimation !== 'body_throw_std'
                        && this.currentUpperAnimation !== 'body_hit'
                        )
                    {
                        this.setUpperAnimation('body_run_bkwd');
                    }
                }
            }
        }

        if(this.x + this.bounds.x + this.bounds.width > this.field.x + this.field.width)
        {
            this.x = this.field.x + this.field.width - this.bounds.x - this.bounds.width;
            this.inertia.x = 0;
        }
        if(this.x + this.bounds.x < this.field.x)
        {
            this.x = this.field.x - this.bounds.x;
            this.inertia.x = 0;
        }
        if(this.y + this.bounds.y + this.bounds.height > this.field.y + this.field.height)
        {
            this.y = this.field.y + this.field.height - this.bounds.y - this.bounds.height;
            this.inertia.y = 0;
        }
        if(this.y + this.bounds.y < this.field.y)
        {
            this.y = this.field.y - this.bounds.y;
            this.inertia.y = 0;
        }

        this.shadow.x = this.x;
        this.shadow.y = this.y;

        this.nextProjectile.x = this.nextProjectilePoint.worldX * this.spine.scale.x;
        this.nextProjectile.y = this.nextProjectilePoint.worldY * this.spine.scale.y;

        if(this.currentUpperAnimation != 'body_idle_victory' &&
           this.currentUpperAnimation != 'body_idle_lose' &&
           this.currentUpperAnimation != 'body_char_ko' &&
           this.nextProjectileShow)
        {
            this.nextProjectile.texture = P3.assets.texture(this.nextProjectileHoldImageName);
        }
        else
        {
            this.nextProjectile.texture = null;
        }

        if((this.gameScene.accumulatedTime - this.lastFire > this.attributes.fireLimit))
        {
            this.readyToFire = true;
        }
    }

    fire()
    {
        if((!this.tutorialMode && !this.readyToFire) || this.incapacitated || this.deactivated) return;

        if(this.spine)
        {
            this.setUpperAnimation('body_throw_std', false);
        }
        this.readyToFire = false;
        this.lastFire = this.gameScene.accumulatedTime;

        this.nextProjectileShow = false;
        this.releaseProjectile();
    }

    releaseProjectile()
    {
        var weapon = this.weapons[this.weapons.length-1];
        this.signals.fireWeapon.dispatch(this, weapon.data, this.nextProjectileData, this.nextProjectileImageName);
        if(weapon.ammo != null)
        {
            weapon.ammo--;
            if(weapon.ammo <= 0)
            {
                this.weapons.pop();
                this.calculateTrajectoryEstimate();
            }
        }
        this.setNextProjectile();
        //this.readyToFire = true;
    }

    hit(damage)
    {
        if(this.spine && this.currentUpperAnimation !== 'body_hit'
            && this.currentUpperAnimation !== 'body_slip_sit_seq'
            && this.currentUpperAnimation !== 'body_idle_sit' 
            && this.currentUpperAnimation !== 'body_idle_victory' 
            && this.currentUpperAnimation !== 'body_idle_lose' 
            && this.currentUpperAnimation !== 'body_char_ko' 
            )
        {
            this.setUpperAnimation('body_hit', false);
        }
        this.healthBar.hit(damage);
    }

    win()
    {
        this.setUpperAnimation('body_idle_victory');
        this.setLowerAnimation('legs_idle_victory');
    }

    lose(ko)
    {
        if(ko)
        {
            this.playingKOAnimation = true;
            this.setUpperAnimation('body_char_ko', false);
            this.setLowerAnimation('legs_idle_ko', false);
            this.dustSpine.state.setAnimation(0, 'char_ko', false);
        }
        else
        {
            this.setUpperAnimation('body_idle_lose');
            this.setLowerAnimation('legs_idle_lose');
        }

        common.audio.playSound(["sfx_knockout_00", "sfx_knockout_01"]);
    }

    addWeapon(type)
    {
        this.weapons.push({data:common.config.weapons.weapons[type], ammo:common.config.weapons.weapons[type].ammo});
        this.setNextProjectile();
        this.calculateTrajectoryEstimate();
    }

    incapacitate()
    {
        this.incapacitated = true;
        this.incapacitatedTimer = this.incapacitatedTimerLimit;
        if(this.spine == null)
        {
            TweenMax.to(this.visual, .3, {alpha:0.5, yoyo:true, repeat:-1, ease:Sine.easeInOut});
        }
        this.setUpperAnimation('body_slip_sit_seq', false);
        this.setLowerAnimation('legs_slip_sit_seq', false);

        this.dustSpine.state.setAnimation(0, 'char_slip_sit_seq', false);
    }

    capacitate()
    {
        this.incapacitated = false;
        this.visual.alpha = 1;
        TweenMax.killTweensOf(this.visual); 
    }

    activate()
    {
        this.deactivated = false;
    }

    deactivate()
    {
        this.deactivated = true;
    }

    setNextProjectile()
    {
        var w = this.weapons[this.weapons.length-1].data;
        this.nextProjectileData = w.projectiles[0];//Math.floor(Math.random() * w.projectiles.length)];
        this.nextProjectileImageName = this.nextProjectileData.images[Math.floor(Math.random() * this.nextProjectileData.images.length)];
        if(!w.powerUp)
        {
            this.nextProjectile.texture = null;
        }
        else
        {
            this.nextProjectileShow = true;
        }
        if(w.image)
        {
            this.nextProjectileHoldImageName = w.image;
            this.nextProjectile.scale.set(common.config.settings.gamePhysics.powerUp.imageScale * 0.75);
        }
        else
        {
            this.nextProjectileHoldImageName = common.config.weapons.images[this.nextProjectileImageName].throw;
            this.nextProjectile.scale.set(common.config.settings.gamePhysics.projectiles.imageScale);
        }
    }

    setUpperAnimation(animation, loop = true)
    {
        if(this.spine.state.hasAnimationByName(animation))
        {
            this.nextProjectileShow = true;
            //this.readyToFire = true;
            this.currentUpperAnimation = animation;
            this.spine.state.setAnimation(0, animation, loop);
        }
    }

    setLowerAnimation(animation, loop = true)
    {
        if(this.spine.state.hasAnimationByName(animation))
        {
            this.currentLowerAnimation = animation;
            this.spine.state.setAnimation(1, animation, loop);
        }
    }

    calculateTrajectoryEstimate()
    {
        if(this.tutorialMode) return;

        this.trajectoryEstimate = [];

        var getAverage = (arr) => {

            var total = 0;
            for(var i in arr)
            {
                total += arr[i];
            }
            return total / arr.length;
        };

        var weaponData = this.weapons[this.weapons.length-1].data.projectiles;
        var physics = common.config.settings.gamePhysics.projectiles;
        var delta = 1 / 30;
        var regDelta = 1 / 10;

        for(var i in weaponData)
        {
            var trajectory = [];
            var frameCount = 0;
            var x = this.projectileOffset.x;
            var y = this.projectileOffset.y;
            var weight = physics.gravity * getAverage(weaponData[i].weight);
            var speedX = (( physics.baseSpeed.x * (weaponData[i].aimAtFighter || getAverage(weaponData[i].xSpeed)) ) * this.attributes.range) * this.field.direction;
            var speedY;
            if(weight == 0)
            {
                speedY = 0;
            }    
            else
            {
                speedY = (physics.baseSpeed.y * getAverage(weaponData[i].ySpeed)) * this.attributes.range;
            }

            while(y <= 0 && this.x + x > this.gameScene.leftField.x && this.x + x < this.gameScene.rightField.x + this.gameScene.rightField.width)
            {
                speedY += weight * delta;
                x += speedX * delta;
                y += speedY * delta;
                frameCount++;
                if(frameCount * delta > trajectory.length * regDelta)
                {
                    trajectory.push({time:this.gameScene.accumulatedTime + (frameCount * delta), x:x, y:y});
                }
            }

            this.trajectoryEstimate = this.trajectoryEstimate.concat(trajectory);
        }

        this.trajectoryEstimateDebug.clear();
        this.trajectoryEstimateDebug.beginFill(0xFFFFFF);
        for(var i in this.trajectoryEstimate)
        {
            this.trajectoryEstimateDebug.drawCircle(this.trajectoryEstimate[i].x, this.trajectoryEstimate[i].y, 5);
        }
        //this.addChild(this.trajectoryEstimateDebug);
    }

    onControlKeyDown(action)
    {
        if(action === 'fire')
            this.fire();
        else if(this.input[action] != null)
            this.input[action] = true;
    }

    onControlKeyUp(action)
    {
        if(this.input[action] != null)
            this.input[action] = false;
    }
}

Fighter.CONTROL_KEYS = 'CONTROL_KEYS';
Fighter.CONTROL_TOUCH = 'CONTROL_TOUCH';
Fighter.CONTROL_VIRTUAL_STICK = 'CONTROL_VIRTUAL_STICK';
Fighter.CONTROL_AI = 'CONTROL_AI';
Fighter.CONTROL_AI_TUTORIAL = 'CONTROL_AI_TUTORIAL';